module.exports = __webpack_public_path__ + "static/media/draw.b967996f.svg";